<script>
    export default {
        name: "ProductReviewsRating",
        props: {
            rating: [Number, String],
        },
    };
</script>

<template>
    <div class="product-reviews-rating">
        <svg
            class="product-reviews-rating__icon"
            :class="{ 'is-active': index <= Math.ceil(rating) }"
            v-for="index in 5"
            :key="index"
            xmlns="http://www.w3.org/2000/svg"
        >
            <use
                xlink:href="/static/assets/reviews/sprites.svg#star-review"
                xmlns:xlink="http://www.w3.org/1999/xlink"
            ></use>
        </svg>
    </div>
</template>

<style lang="scss">
    .product-reviews-rating {
        display: flex;
        align-items: center;
        margin: 0 -1px;
        @include bp($bp-desktop-sm) {
            margin: 0 -2px;
        }
    }

    .product-reviews-rating__icon {
        @include box(14px);
        margin: 0 1px;
        fill: var(--product-reviews-star-empty);
        &.is-active {
            fill: var(--product-reviews-star-color);
        }
        @include bp($bp-desktop-sm) {
            @include box(24px);
            margin: 0 2px;
        }
    }
</style>
